









































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from "@/const";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";

@Component({
  components: {
  }
})
export default class InsertionModal extends Vue 
{
    private get title() { return "デザイン選択"; }
    private get message1() { return "デザインを「テンプレート」から作成するか「ラベル屋さん保存ファイル（" + Const.PROJECT_FILE_EXTENSION + ")」"; }
    private get message2() { return "から作成するか選択してください。"; }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
